<div class="progress-wrapper" id="main-content">
    <ridango-page-content-wrapper>
        <ridango-progress-v2 [steps]="steps$ | async" [activeStep]="activeStep$ | async"> </ridango-progress-v2>
    </ridango-page-content-wrapper>
</div>
<div class="block--content block">
    <div class="block--wrap well well--collapsing container block">
        <rwidget-alert></rwidget-alert>
    </div>
    <ridango-ui-basic-loading-spinner *ngIf="productsLoading$ | async"> </ridango-ui-basic-loading-spinner>
    <div class="ticket" *ngIf="(productsLoading$ | async) === false">
        <ridango-page-content-wrapper>
            <!-- products -->
            <rwidget-product-selector [step]="1" [isEmpty]="false" [locale]="selectedLanguageCode">
            </rwidget-product-selector>
            <!-- medium -->
            <rwidget-purchase-medium [locale]="selectedLanguageCode" [step]="2" [isEmpty]="false">
            </rwidget-purchase-medium>
        </ridango-page-content-wrapper>
        <!-- summary -->
        <div class="block--bg-wrapper ticket-summary">
            <h2 class="title-bg-wrapper">
                {{ 'PAGE_TITLE_YOUR_TICKET' | translate }}
            </h2>
            <ridango-page-content-wrapper>
                <rwidget-purchase-summary
                    [flowCompleted]="isFlowCompleted$ | async"
                    [locale]="selectedLanguageCode"
                    [tickets]="convertPayloadsToLocalTickets(payloads$ | async)"
                    (postPayloads)="postToCart()">
                </rwidget-purchase-summary>
            </ridango-page-content-wrapper>
        </div>
    </div>
</div>
